import { Box, Card, CardContent, Grid, Pagination, Stack, Typography } from '@mui/material';
import { Height, LocationOn } from '@mui/icons-material';
import { useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { platform, productTypeStatus } from '../../utils/enum/search-branches-enum';
import iconElectric from '../../assets/images/icon-electric.png';
import iconMobile from '../../assets/images/icon-mobile.png';
import logoCJ from '../../assets/images/logo-cj.png';
import logoCJx from '../../assets/images/logo-cjx.png';
import iconFresh from '../../assets/images/icon-fresh.png';
import iconMiniAtm from '../../assets/images/icon-mini-atm.png';
import iconTablet from '../../assets/images/icon-tablet.png';
import { content } from '../../contentData/branches';
import { Responsive } from '../../utils/enum/responsive-enum';
import bgCjDesktop from '../../assets/images/bg-cj-desktop.png';
import bgCjMobile from '../../assets/images/bg-cj-mobile.png';
import bgCjxDesktop from '../../assets/images/bg-cjx-desktop.png';
import bgCjxMobile from '../../assets/images/bg-cj-mobile.png';

export interface SearchProp {
  list: [];
}

export default function SearchBranchesListDesktop({ list }: SearchProp) {
  const handleMap = (googleMap: string) => {
    let a = document.createElement('a');
    a.target = '_blank';
    a.href = googleMap;
    a.click();
  };

  const [page, setPage] = useState<number>(1);
  const itemPerpage = 20;
  const total = list.length;
  const countpage = Math.ceil(total / Number(itemPerpage));
  const [startIndex, setStartIndex] = useState<number>(0);
  const [endIndex, setEndIndex] = useState(itemPerpage);

  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setStartIndex(itemPerpage * (value - 1));
    setEndIndex(itemPerpage * value);
    setPage(value);
  };

  const isTabletOrMobile = useMediaQuery({ query: `(max-width: ${Responsive.TABLE_OR_MOBILE})` });

  const cardStyle = {
    borderRadius: '8px',
    boxShadow: '0 4px 12px #cccccc',
    backgroundSize: '100% 100%',
    backgroundRepeat: 'no-repeat',
    backgroundImage: `url(${isTabletOrMobile ? bgCjMobile : bgCjDesktop} )`,
  };

  const cardStyleCjx = {
    borderRadius: '8px',
    boxShadow: '0 4px 12px #cccccc',
    backgroundSize: '100% 100%',
    backgroundRepeat: 'no-repeat',
    backgroundImage: `url(${isTabletOrMobile ? bgCjxMobile : bgCjxDesktop} )`,
  };

  const btnStyle = {
    color: '#6d6d6d',
    borderRadius: '20px',
    background: '#edecec',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // width: isTabletOrMobile ? '15px' : '95px',
    padding: '4px 4px 4px 0px',
  };

  return (
    <>
      <Grid container spacing={2} rowSpacing={2}>
        {list && (
          <>
            {list.slice(startIndex, endIndex).map((merchantInfo: any) => {
              return (
                <>
                  <Grid item xs={3}>
                    <Box
                      sx={{ ...cardStyle, ...(merchantInfo.Platform === platform.CJ ? cardStyle : cardStyleCjx) }}
                      p={2}>
                      {/* <Box> */}
                      {/* {merchantInfo.Platform === platform.CJ && <img src={logoCJ} width={24} height={24} alt="" />} */}
                      {/* {merchantInfo.Platform === platform.CJX && <img src={logoTD} width={24} height={24} alt="" />} */}
                      <Box sx={{ width: '110px' }}>
                        {merchantInfo.Platform === platform.CJ && (
                          <Box
                            sx={{
                              ...btnStyle,
                            }}>
                            <img src={logoCJ} width={24} height={24} alt="" style={{ marginRight: '8px' }} />
                            {content.platform.cj}
                          </Box>
                        )}
                        {merchantInfo.Platform === platform.CJX && (
                          <Box
                            sx={{
                              ...btnStyle,
                            }}>
                            <img src={logoCJx} width={24} height={24} alt="" style={{ marginRight: '8px' }} />
                            {content.platform.cjx}
                          </Box>
                        )}
                      </Box>

                      <Typography sx={{ fontSize: '18px', fontWeight: 700, color: '#7A7A7A', minHeight: 54 }} pt={1}>
                        {merchantInfo.Merchant_Name_Detail}
                      </Typography>

                      <Typography sx={{ fontSize: '16px', fontWeight: 400, color: '#7A7A7A', minHeight: 72 }}>
                        ที่อยู่ {merchantInfo.Address_Line1}{' '}
                        {merchantInfo.Province === 'กรุงเทพมหานคร' ? 'แขวง' : 'ตำบล'}
                        {merchantInfo.Subdistrict} {merchantInfo.Province === 'กรุงเทพมหานคร' ? 'เขต' : 'อำเภอ'}
                        {merchantInfo.District} จังหวัด{merchantInfo.Province} {merchantInfo.Zip_Code}
                      </Typography>

                      <Box sx={{ minHeight: '30px' }} pt={1} display="grid" gridTemplateColumns="1fr 1fr 1fr" gap={0.5}>
                        {merchantInfo.Mobile_Phone === productTypeStatus.YES && (
                          <>
                            <Box sx={{ display: 'flex' }}>
                              <img src={iconMobile} width={24} height={24} style={{ marginRight: '8px' }} alt="" />
                              <Typography sx={{ fontSize: '12px', fontWeight: 700, color: '#7A7A7A' }} mt={0.5}>
                                มือถือ
                              </Typography>
                            </Box>
                          </>
                        )}
                        {merchantInfo.Tablet === productTypeStatus.YES && (
                          <>
                            <Box sx={{ display: 'flex' }}>
                              <img src={iconTablet} width={24} height={24} style={{ marginRight: '8px' }} alt="" />
                              <Typography sx={{ fontSize: '12px', fontWeight: 700, color: '#7A7A7A' }} mt={0.5}>
                                แท็บเล็ต
                              </Typography>
                            </Box>
                          </>
                        )}
                        {merchantInfo.Mini_ATM === productTypeStatus.YES && (
                          <>
                            <Box sx={{ display: 'flex' }}>
                              <img src={iconMiniAtm} width={24} height={24} style={{ marginRight: '8px' }} alt="" />
                              <Typography sx={{ fontSize: '12px', fontWeight: 700, color: '#7A7A7A' }} mt={0.5}>
                                ตู้เงินดี
                              </Typography>
                            </Box>
                          </>
                        )}
                      </Box>
                      <Box sx={{ minHeight: '30px' }} pt={1} display="grid" gridTemplateColumns="1fr 1fr" gap={0.2}>
                        {merchantInfo.Electrical_Appliance === productTypeStatus.YES && (
                          <>
                            <Box sx={{ display: 'flex' }}>
                              <img src={iconElectric} width={24} height={24} style={{ marginRight: '8px' }} alt="" />
                              <Typography sx={{ fontSize: '12px', fontWeight: 700, color: '#7A7A7A' }} mt={0.5}>
                                เครื่องใช้ไฟฟ้า
                              </Typography>
                            </Box>
                          </>
                        )}
                        {merchantInfo.Loan_Fresh === productTypeStatus.YES && (
                          <>
                            <Box sx={{ display: 'flex' }}>
                              <img src={iconFresh} width={24} height={24} style={{ marginRight: '8px' }} alt="" />
                              <Typography sx={{ fontSize: '12px', fontWeight: 700, color: '#7A7A7A' }} mt={0.5}>
                                สินเชื่อหมุนเวียน
                              </Typography>
                            </Box>
                          </>
                        )}
                      </Box>
                      <Box
                        sx={{ cursor: 'pointer', display: 'flex', justifyContent: 'end' }}
                        onClick={() => {
                          handleMap(merchantInfo.Google_map_url);
                        }}>
                        <LocationOn sx={{ color: '#008330', fontSize: 'x-large' }} />
                        <Typography sx={{ color: '#008330', fontSize: '12px', fontWeight: 700 }} pb={2} mr={3}>
                          ดูแผนที่
                        </Typography>
                      </Box>
                      {/* </Box> */}
                    </Box>
                  </Grid>
                </>
              );
            })}
          </>
        )}
      </Grid>
      {list.length > 0 && (
        <>
          <Box mt={3} justifyContent={'center'} display={'flex'}>
            <Stack spacing={2}>
              <Pagination count={countpage} page={page} variant="outlined" onChange={handleChange} />
            </Stack>
          </Box>
        </>
      )}
    </>
  );
}
